interface Props {
  seats: number;
  included: number;
  additional: number;
  /** Preço de uma licença no período; ausente enquanto o plano/moeda não está definido. */
  unitAmount?: number | null;
  currency?: string;
  /** Soma opcional de itens fora do plano (ex.: produto de API). */
  extraAmount?: number;
  formatPrice: (amount: number, currency?: string) => string;
}

/** Decomposição do contrato: licenças simultâneas, canais incluídos (sem custo) e canais adicionais (preço de 1 licença cada). */
export function CompanyCapacitySummary({ seats, included, additional, unitAmount, currency, extraAmount = 0, formatPrice }: Props) {
  const priced = unitAmount != null && unitAmount > 0;
  const money = (amount: number) => formatPrice(amount, currency);
  const total = priced ? unitAmount * (seats + additional) + extraAmount : null;
  return <div role="group" aria-label="Resumo da capacidade contratada" className="space-y-2 rounded-lg border border-gray-200 bg-gray-50/60 p-3 text-sm"><dl className="space-y-2">
    <div className="flex flex-wrap justify-between gap-2"><dt>Licenças simultâneas</dt><dd>{seats}{priced ? ` × ${money(unitAmount)} = ${money(unitAmount * seats)}` : ''}</dd></div>
    <div className="flex flex-wrap justify-between gap-2"><dt>Canais incluídos no plano</dt><dd>{included} (sem custo adicional)</dd></div>
    <div className="flex flex-wrap justify-between gap-2"><dt>Canais adicionais contratados</dt><dd>{additional}{priced ? ` × ${money(unitAmount)} = ${money(unitAmount * additional)}` : ''}</dd></div>
    <div className="flex flex-wrap justify-between gap-2 border-t border-gray-200 pt-2"><dt>Total de canais</dt><dd className="font-medium">{included} incluídos + {additional} adicionais = {included + additional}</dd></div>
    {total != null ? <div className="flex flex-wrap justify-between gap-2 font-semibold"><dt>Total por período</dt><dd>{money(total)}</dd></div> : null}
    </dl>
    <p className="text-xs text-gray-500">Cada canal adicional custa o mesmo que uma licença do plano{priced ? ` (${money(unitAmount)})` : ''}. As licenças definem quantos usuários podem estar conectados ao mesmo tempo; não limitam os usuários cadastrados.</p>
  </div>;
}
